/** Stored URL identities are separate from display names, auth usernames and invite codes. */
export const PROFILE_SLUG_MAX_LENGTH = 96;
const slugPattern = /^[a-z0-9]{1,96}$/;
export function canonicalSlug(value: string): string {
    const slug = typeof value === 'string' ? value.toLowerCase() : '';
    if (!slugPattern.test(slug)) { throw new Error('Invalid profile link.'); }
    return slug;
}
export function userProfilePath(slug: string): string {
    return '/streaker-central/streakers/' + canonicalSlug(slug);
}
export function teamProfilePath(challengeId: number, slug: string): string {
    if (!Number.isSafeInteger(challengeId) || challengeId <= 0 || challengeId > 2147483647) { throw new Error('Invalid challenge link.'); }
    return '/streaker-central/teams/' + canonicalSlug(slug);
}
